/**
 * @Author : zhouqinze
 * @Date : 2019-12-30
 * @Version : 1.0
 * @Content : 公司简介
 **/
<template>
        <div>
            <div class="aboutComHead">
                <p>公司简介</p>
                <p><span></span><span></span></p>
            </div>
            <div class="aboutComText">
                <p>广州通易科技有限公司，是一家专注于智慧交通信息化建设及提供驾驶出行服务的高新技术企业，连续多年获得“高新技术企业”、 广东省守合同重信用企业，质量管理体系ISO9001等认证，是广州市首批企业研究开发机构</p>
                <p>公司致力于数字交通、企业数字化转型、驾驶出行及服务等领域研究与市场应用，提供量身定做的管理软件、解决方案及服务，目前业务范围遍及国内，为超过30万企业事业单位及个人提供服务</p>
                <p>公司拥有一批包括博士、硕士在内的强大研发团队，拥有超强的持续创新能力，目前已申请发明专利12项，获得发明专利6项，实用 新型专利10项，著作权38项，高新产品认证4项</p>
                <p>通易始终秉承“创新”，“责任”，“分享”，“主动”，“服务”的价值观，以创新实践，服务交通行业发展为使命，立志成为国 内知名的智慧交通提供商、智能网汽车产品服务商</p>
            </div>
        </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    // .content{
    //         width: 1200px;
    //         height: 100%;
    //         margin: auto;
    //         display: flex;
    //         justify-content: space-between;
                .aboutComHead{
                    width: 5.875rem;
                    font-size: 1.4375rem;
                    color: #333;
                    margin-bottom: .75rem;
                    font-weight: bold;
                    span{
                        display: inline-block;
                        width: 50%;
                        height: .1875rem;
                        background: #018CF4;
                    }
                    span:last-child{
                        background: #ddd;
                    }
                }
                .aboutComText{
                    font-size: 1rem;
                    color: #333;
                    padding-top: 2.125rem;
                    margin-bottom: 6.1875rem;
                    p{
                        height: 2.5rem;
                        width: 52.6875rem;
                        font-weight: 400;
                        text-align: left;
                        margin-bottom: 2.375rem;
                    }
                    p:last-child{
                        margin-bottom: 0;
                    }
                }
        // }
</style>